import ContentPageTopButtons from "../../../Components/ContentPageTopButtons"
import ErrorIndicator from "../../../Components/ErrorIndicator";
import List from "../../../Components/List";
import LoadingIndicator from "../../../Components/LoadingIndicator";
import { getRegionFounderDetailsAsync } from "../../../services/adminService";
import { useAsync } from "../../../utilities/customHooks";
import { DetailsContentHeader } from "../ProfilePages/NewAdmin"
import { contentPageContainerStyle, contentPageWrapperStyle } from "../ProfilePages/PartnerAdminList"

const NoProfile = () => {
    
  const founderDetailsAsync = useAsync(() => getRegionFounderDetailsAsync(), []);

  if (founderDetailsAsync.status === "pending") {
    return <LoadingIndicator />;
  }
  
  if (founderDetailsAsync.status === "rejected") {
    return <ErrorIndicator />;
  }

  const { foundersWithNoApplications } = founderDetailsAsync.value.regionalFounderDetails;


  const columnHeaderData = [
    {
      header: "Email",
      key: "email"
    },
    {
      header: "Date Registered",
      key: "createdAt"
    }
  ]

  return (
    <div className="resourcesCont !pt-0">
      <div className="flex flex-col w-full">
        <h2 className="mb-4">Companies with Unsubmitted Applications</h2>
        <List 
          contentArray={foundersWithNoApplications}
          columnHeaderData={columnHeaderData}
        />
      </div>
    </div>  
  )
}

export default NoProfile